import { useLazyQuery } from '@apollo/client/react';
import { useAtomValue } from 'jotai';
import { useEffect } from 'react';

import {
  GetPatientProfileFollowupAppointmentDocument,
  PatientProfileFollowupPatientFragment,
} from '~/graphql/generated/graphql';
import { getNode } from '~/graphql/utility';
import { medicationFollowupModalState } from '~/state/partials/patient_profile_drawer/atoms';

type Patient = {
  loading: boolean;
  patient?: PatientProfileFollowupPatientFragment;
};

export const useFetchPatient = (): Patient => {
  const { isOpen, appointmentId } = useAtomValue(medicationFollowupModalState);

  const [getAppointment, { loading, data }] = useLazyQuery(
    GetPatientProfileFollowupAppointmentDocument,
  );
  const patient = getNode(data, 'Appointment')?.patient || undefined;

  useEffect(() => {
    if (isOpen && appointmentId) {
      getAppointment({ variables: { appointmentId } });
    }
  }, [appointmentId, getAppointment, isOpen]);

  return { loading, patient };
};
